<template>
  <div class="wrapper">
    <div class="header">
      <el-input class="search" size="mini" placeholder="请输入您想要搜索的试卷名称" v-model="form.paper_name" clearable @keyup.enter.native="search">
      </el-input>
      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="search">查询</el-button>

      <el-button class="search_btn" type="primary" size="mini" icon="el-icon-edit" @click="CreatePaper">新增试卷</el-button>
    </div>

    <div class="question_wrapper">
      <el-table size="small" :data="examlist" :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }" stripe>
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (form.page_no - 1) * 20 }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="试卷名称" prop="title">
        </el-table-column>

        <el-table-column align="center" label="试题数量" prop="total_num">
        </el-table-column>

        <el-table-column align="center" label="总分" prop="total_score">
        </el-table-column>

        <el-table-column width="200" align="left" label="创建日期" prop="created_time">
        </el-table-column>

        <el-table-column align="left" label="创建人" prop="realname">
        </el-table-column>

        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="EditQuestions(scope.row)" type="text" size="mini">编辑</el-button>
            <el-button @click="StartExam(scope.row)" type="text" size="mini">发起考试</el-button>

            <el-dropdown>
              <span class="el-dropdown-link">
                更多
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="goPay(scope.row)">报名课程</el-dropdown-item> -->

                <el-dropdown-item @click.native="LookPaper(scope.row)">预览试卷</el-dropdown-item>
                <el-dropdown-item @click.native="PaperCopy(scope.row.id)">拷贝试卷</el-dropdown-item>
                <el-dropdown-item @click.native="deletePaper(scope.row.id)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="form.page_no" layout="total, prev, pager, next" :page-size="form.page_size" :total="form.total"></el-pagination>
    </div>

    <el-dialog title="新增题库" :visible.sync="dialogVisible" width="40%">
      <el-form class="form-style" :model="form" size="mini" label-position="left">
        <el-form-item label="序号" required prop="sort_num">
          <el-input-number v-model="form.sort_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="所属科目" required prop="subject_id">
          <el-select v-model="form.subject_id" placeholder="请选择" filterable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题库名称" required prop="title">
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-form-item label="简介" required>
          <el-input type="textarea" v-model="form.desc" placeholder="请输入题库的简介"></el-input>
        </el-form-item>

        <el-form-item label="封面" required prop="img_url">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :file-list="form.imgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="color: red">推荐尺寸(750*340)</span>
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSchoolPaperList, deletePaper, copyPaper } from "@/api/educational";

export default {
  name: "paper-management",
  data() {
    return {
      examlist: [],

      //试卷搜索
      form: {
        paper_name: "",
        subject_id: "",
        search_user_id: "",
        owned: true,
        page_no: 1,
        page_size: 20,
        total: 0,
      },
      subjectList: [],
      dialogVisible: false, //新增题库
    };
  },

  mounted() {
    this.getSchoolPaperList();
  },

  methods: {
    search() {
      this.form.page_no = 1;
      this.getSchoolPaperList();
    },

    getSchoolPaperList() {
      getSchoolPaperList({
        title: this.form.paper_name,
        subject_id: this.form.subject_id,
        isShowSelfPaper: this.form.owned,
        search_user_id: this.form.search_user_id,
        page_no: this.form.page_no,
        page_size: this.form.page_size,
      }).then((res) => {
        console.log("试卷列表");
        console.log(res);
        this.examlist = res.paperList;
        this.form.total = res.total;
      });
    },

    //删除试卷
    deletePaper(id) {
      this.$confirm("确定删除该试卷吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deletePaper({
          paper_id: id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success("删除成功！");
            this.getSchoolPaperList();
          }
        });
      });
    },

    PaperCopy(id) {
      this.$prompt("请输入试卷副本的名称?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            console.log("试卷副本名称");
            console.log(value);

            this.copyPaper(id, value);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },

    copyPaper(id, value) {
      copyPaper({
        paper_id: id,
        paper_title: value,
      }).then((res) => {
        console.log("复制试卷");
        console.log(res);
        if (res.is_create) {
          this.$message.success("试卷拷贝成功");
          this.getSchoolPaperList();
        }
      });
    },

    //添加试题
    AddQuestion(row) {
      console.log("添加试题");
      console.log(row);
      this.$router.push({
        name: "add-question",
        query: {
          id: row.id,
          title: row.title,
        },
      });
    },
    QuestionManagement(row) {
      console.log("试题管理");
      console.log(row);
      this.$router.push({
        name: "questionlist",
        query: {
          id: row.id,
          title: row.title,
        },
      });
    },
    Practice(row) {
      console.log("练习");
      console.log(row);
      this.$router.push({
        name: "practice",
        query: {
          id: row.id,
          title: row.title,
        },
      });
    },

    CreatePaper() {
      console.log("创建考试");
      this.$router.push({
        name: "create-paper",
      });
    },

    LookPaper(row) {
      console.log("查看试卷");
      console.log(row);
      console.log("挑战模板1");
      console.log(this.project_url);

      // let routeUrl = this.$router.resolve({
      //   name: "paper-detail",
      //   query: { id: row.id, title: row.title },
      // });

      // window.open(routeUrl.href, "_blank");
      this.$router.push({
        name: "paper-detail",
        query: { id: row.id, title: row.title },
      });
    },

    StartExam(row) {
      console.log("试卷参数");
      console.log(row);

      this.$router.push({
        name: "start-exam",
        query: {
          id: row.id,
          subject_id: row.subject_id,
          total_num: row.total_num,
          total_score: row.total_score,
        },
      });
    },

    EditQuestions(row) {
      console.log("编辑试题");
      console.log(row);

      this.$router.push({
        name: "edit-questions",
        query: {
          id: row.id,
          title: row.title,
          bank_ids: row.questionBankIds,
        },
      });
    },

    handleCurrentChange(val) {
      this.form.page_no = val;
      this.getSchoolPaperList();
    },
    handleChangeFile() { },
    handleRemove() { },
    uploadFile() { },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;
  .header {
    .search {
      width: 250px;
    }
    .search_btn {
      margin-left: 20px;
    }
  }

  .question_wrapper {
    margin-top: 20px;

    .quest_btn {
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
    padding-left: 10px;
  }
}
</style>
